import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-gray-300 px-6 md:px-16 pt-12 pb-8">
      <div className="max-w-7xl mx-auto">
        {/* Top Section with 4 Columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-16 text-left">
          
          {/* About */}
          <div className="text-left">
            <h2 className="text-xl font-bold text-white mb-4">About Us</h2>
            <p className="text-sm leading-relaxed">
              We are a leading training institute providing high-quality
              courses to help students and professionals enhance their
              skills and grow in their careers.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-left">
            <h2 className="text-xl font-bold text-white mb-4">Quick Links</h2>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-pink-400">Home</Link></li>
              <li><Link to="/about" className="hover:text-pink-400">About</Link></li>
              <li><Link to="/courses" className="hover:text-pink-400">Courses</Link></li>
              <li><Link to="/contact-us" className="hover:text-pink-400">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-left">
  <h2 className="text-xl font-bold text-white mb-4">Contact Us</h2>
  <ul className="space-y-2 text-sm">
    <li>SHOP NO. 25 1ST FLOOR SAMDARIYA GOLD SIRMAUR CHAURAHA, REWA</li>
    <li>
      Phone: <a href="tel:+919755897963" className="underline">+91 9755897963</a>
    </li>
    <li>
      Mob: <a href="tel:+918821837091" className="underline">+91 8821837091</a>
    </li>
    <li>Email: <a href="mailto:Sarvagystech@gmail.com" className="underline">Sarvagystech@gmail.com</a></li>
  </ul>
</div>

          {/* Social Media */}
          <div className="text-left">
            <h2 className="text-xl font-bold text-white mb-4">Follow Us</h2>
            <div className="flex gap-4 text-xl">
              <a href="https://www.facebook.com/profile.php?id=61584861796437" className="hover:text-pink-400"><FaFacebook /></a>
              <a href="https://www.instagram.com/sarvagystech" className="hover:text-pink-400"><FaInstagram /></a>
              <a href="https://www.youtube.com/@SARVAGYStech" className="hover:text-pink-400"><FaYoutube/></a>
              {/* <a href="#" className="hover:text-pink-400"><FaLinkedin /></a> */}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 mt-10 pt-6 flex flex-col md:flex-row items-center md:items-start justify-between text-sm text-gray-400 text-left">
          <p>© {new Date().getFullYear()} Sarvagys Institute. All rights reserved.</p>
          <Link to="/privacy-policy" className="hover:text-pink-400 mt-4 md:mt-0">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
